import React, { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import RelatedLinks from '../RelatedLinks';
import FruitsZakatTable from './FruitsZakatTable';
import { SERVER_URL } from '../ConstantsEN';
import { Fruits_Zakat_EndPoint } from '../ConstantsEN';
import { CalculatorsType } from '../ConstantsEN';
import SharedHelmet from "../Helmet";
const TITLE = 'Fruits Zakat Calculator - Calculate Zakat on Fruits Precisely and Easily';
const DESCRIPTION = 'The Fruits Zakat Calculator is a tool used to calculate the eligible zakat amount for fruits in accordance with Islamic Sharia laws. This calculator is used to determine the financial amount that must be paid as zakat for harvested fruits.';
const KEYWORDS = 'Fruits Zakat Calculator, Calculate Your Fruits Zakat, Fruits Zakat, Fruits Zakat Calculation Methods, Fruits Zakat Amount, Fruits Zakat Rules, Calculate Fruits Zakat in Islam, Fruits Zakat in Islamic Sharia, How to Calculate Fruits Zakat, Fruits Zakat Threshold Calculator, Calculate Fruits Zakat Threshold, Fruits Zakat Calculator, Fruits Zakat Amount Calculation, Fruits Zakat Threshold in Islam';
const OG_URL = 'https://do-calculate.com/calculator/en/fruits-zakat/';
const apiEndpoint = `${SERVER_URL}/${Fruits_Zakat_EndPoint}`;
function FruitsZakatCalculator() {
    const [pricePerKg, setPricePerKgSilver] = useState(0);
    const [weight, setWeight] = useState(0);
    const [result, setResult] = useState(null);
    const [statusCode, setStatusCode] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [wateringMethod, setWateringMethod] = useState('');
    const handleWeightChange = (event) => {
        setWeight(event.target.value);
    };
    const handleWateringMethodChange = (event) => {
        setWateringMethod(event.target.value);
    };
    const handlePricePerKgChange = (event) => {
        setPricePerKgSilver(event.target.value);
    };
    const calculateFruitsZakat = async () => {
        setIsLoading(true);
        try {
            const response = await fetch(apiEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ weight, pricePerKg, wateringMethod }),
            });
            const data = await response.json();
            setStatusCode(response.status);
            if (response.ok) {
                setResult(data.result);
            } else {
                setResult(null);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <div>
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px' }}>
                        <h1 style={{ fontSize: '15px' }}>Calculate Fruits Zakat</h1>
                    </div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                The Fruits Zakat Calculator is a tool used to calculate the eligible zakat amount for fruits in accordance with Islamic Sharia laws. This calculator is used to determine the financial amount that must be paid as zakat for harvested fruits.
                                <br />
                                <hr />
                            </div>
                            <br />
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-5 calculatorStyle">
                                <div className='p-3 mb-2 bg-success text-white'>
                                    Fruits Zakat
                                </div>
                                <hr />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='weightNumber' className="form-label ms-2">Total Weight of Fruits and Crops</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="weightNumber"
                                        value={weight}
                                        onChange={handleWeightChange}
                                        className="form-control ml-2"
                                        style={{ width: '75px' }}
                                    />
                                    <div className="input-group-append">
                                        <span className="input-group-text">kg</span>
                                    </div>
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='pricePerKgNumber' className="form-label ms-2">Price per Kilogram</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="pricePerKgNumber"
                                        value={pricePerKg}
                                        onChange={handlePricePerKgChange}
                                        className="form-control ml-2"
                                        style={{ width: '75px' }}
                                    />
                                </div>
                                <br />
                                <div>
                                    <b>
                                        <label htmlFor="method" className="form-label ms-2">Watering Method Used</label>
                                    </b>
                                    <select id="method" className="form-select" value={wateringMethod} onChange={handleWateringMethodChange} >
                                        <option value="">-- Select Method --</option>
                                        <option value="no-cost">No Cost</option>
                                        <option value="mid-cost">Mid Cost</option>
                                        <option value="full-cost">Full Cost</option>
                                    </select>
                                </div>
                                <br />
                                <hr />
                                <button className="btn btn-success" style={{ fontSize: '20px' }} onClick={calculateFruitsZakat} disabled={isLoading}>
                                    {isLoading ? (
                                        <div className="spinner-border spinner-border-sm" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    ) : (
                                        'Calculate'
                                    )}
                                </button>
                            </div>
                            <div className="col-sm-12 col-md-7">
                                <br />
                                {statusCode === 400 && <div className="alert alert-warning"><b><u>Error:</u></b> Please enter all fields correctly.</div>}
                                {result &&
                                    (
                                        <div>
                                            <h4><div className="p-3 mb-2 bg-success text-white">Results:</div></h4>
                                            <hr />
                                            <FruitsZakatTable result={result}></FruitsZakatTable>
                                        </div>
                                    )}
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="col" >
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.islamicCalculators}></MainCalculatorsList>
                    <br />
                </div>
            </div>
            <div className="row" style={{ height: 'auto' }} >
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">Description of Fruits and Crops Zakat Calculator</div>
                            <div className="info-section-body">
                                <u><b>Fruits Zakat Calculator</b></u> <br/>                                The calculator takes three parameters:
                                <ul>
                                    <li>Fruit Weight (in kilograms)</li>
                                    <li>Price per kilogram of fruit</li>
                                    <li>Irrigation Method</li>
                                </ul>
                                The calculator calculates the Zakat for fruits based on the following factors:
                                <ul>
                                    <li>If irrigation is free, the Zakat rate is 10%</li>
                                    <li>If irrigation incurs full cost, the Zakat rate is 5%</li>
                                    <li>If irrigation incurs average cost, the Zakat rate is 7.5%</li>
                                </ul>
                                Then, the Zakat value for fruits is calculated in kilograms and monetary value based on weight, Zakat rate, and the price per kilogram of fruit. The minimum Zakat threshold for fruits is set at 635 kilograms.
                                <br/>                                The calculator returns the result in an object containing the following information:
                                <ul>
                                    <li>Zakat value for fruits in kilograms.</li>
                                    <li>Monetary value of Zakat for fruits.</li>
                                    <li>Minimum Zakat threshold for fruits.</li>
                                </ul>
                                <br />
                                <hr />
                                <b>Source: </b>
                                <a href="https://www.islamweb.net/ar/fatwa/119852/%D8%B2%D9%83%D8%A7%D8%A9%D9%8F-%D8%A7%D9%84%D8%B2%D9%91%D9%8E%D8%B1%D9%8E%D8%B9%D9%90-%D8%A7%D9%84%D9%88%D9%8E%D8%A7%D8%AD%D9%90%D8%AF%D9%90-%D8%A5%D8%B0%D8%A7-%D8%A7%D8%AC%D8%AA%D9%8E%D9%85%D9%8E%D8%B9-%D9%81%D9%90%D9%8A%D9%87-%D8%A7%D9%84%D8%B3%D9%91%D9%8E%D9%82%D9%92%D9%8A%D9%8F-%D8%A8%D9%90%D9%85%D9%8E%D8%A7%D8%A1%D9%90-%D8%A7%D9%84%D8%B3%D9%91%D9%8E%D9%85%D9%8E%D8%A7%D8%A1%D9%90-%D9%88%D8%A7%D9%84%D8%A2%D9%84%D9%8E%D8%A9#:~:text=%D9%83%D9%85%D8%A7%20%D8%A3%D9%86%20%D8%A7%D9%84%D8%AC%D9%8F%D9%84%D8%A8%D8%A7%D9%86%20%D8%AA%D8%AC%D8%A8%D9%8F%20%D9%81%D9%8A%D9%87,%D9%88%D9%82%D9%8A%D9%84%D9%8E%20%D8%A8%D9%84%20%D9%8A%D9%8F%D8%B9%D8%AA%D8%A8%D8%B1%D9%8F%20%D8%A8%D8%A7%D9%84%D8%A3%D8%BA%D9%84%D8%A8%20%D9%85%D9%86%D9%87%D9%85%D8%A7">
                                    IslamWeb
                                </a> <br />
                                <b>Last Reviewed On: </b>
                                05/07/2023
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default FruitsZakatCalculator;
